module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-LEANLINK-0107-616bba8fb39d80d83ae1cc9696b63b03.png";